import React, { useEffect } from "react";

export default function AppRedirect() {
  useEffect(() => {
    window.location.replace('http://diz.app.link/zpsaB8wtZvb')
  },[]);

  return <div></div>;
}
